import { Alias } from '../../alias/models/alias';
import { Dge } from '../../engines/models/dge';
import { Notification } from '../models/notification';

export class NotificationOptions {

    constructor(
        readonly notifications: Notification[],
        readonly alias: Alias[],
        readonly dges: Dge[]
    ) { }
}

